<template>
  <section class="footer">
    <div class="container">
      <div class="row">
        <div class="col-md-6">
          <div class="footer-info">
            <div class="logo">
              <img v-bind:src="require('../assets/img/logo.webp')"/>
            </div>
            <div class="info">
              <a class="btn-smartville">
                {{ messages.footer.download.text }}
              </a>
            </div>
            <a class="btn-smartville" v-bind:href="messages.footer.smartville_my.href" target="_blank">
              {{ messages.footer.smartville_my.text }}
            </a>
          </div>
        </div>
        <div class="col-md-6">
          <div class="info">
            <div class="row">
              <div class="col-md-6">
                <a href="https://play.google.com/store/apps/details?id=gr.ianic.smartville" target="_blank">
                  <img class="android" v-bind:src="require('./../assets/img/android.svg')" alt="Smartville Android App" height="180">
                </a>
                <a href="https://apps.apple.com/gr/app/smartville/id1596791470" target="_blank">
                  <img class="ios" v-bind:src="require('./../assets/img/ios.svg')" alt="Smartville IOS App" height="180">
                </a>
              </div>
              <div class="col-md-6">
                <img class="qr" v-bind:src="require('./../assets/img/qr.svg')" alt="Smartville Mobile QR code" height="180">
              </div>
            </div>
            <div class="copyright">
              <a href="https://ianic.eu" target="_blank">
                Born & Raised by IANIC
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "footer_component",
  data(){
    return {
      messages: {}
    };
  },
  beforeMount() {
    this.messages = window.messages;
  }
}
</script>

<style scoped>

</style>